import {Pipe, PipeTransform} from '@angular/core';
import {FormType} from "../types/form.enum";

/*
 * Select alias according to the type
 * Usage:
 *   value | templateType: FormType
 * Example:
 *   {{ "ATTACHMT / TAXCOMP" | templateType:FormType.IRB1 }}
 *   formats to: "ATTACHMT"
*/
@Pipe({
    name: 'templateType',
    standalone: false
})
export class TemplateTypePipe implements PipeTransform {
  transform(templateAlias: string|null, formType: FormType): string|null {
    if (templateAlias === null) {
      return templateAlias;
    }
    const parts = templateAlias.split("/");
    if (parts.length === 2) {
      switch (formType) {
        case FormType.IRB1:
          return parts[0].trim();
        case FormType.IR21:
          return parts[1].trim();
        case FormType.NULL:
          return "";
        case FormType.UNKNOWN:
          return templateAlias;
        default:
          return templateAlias;
      }
    } else {
      return templateAlias;
    }
  }
}
